module.exports = __webpack_public_path__ + "static/media/navExportedActive.4c13fa69.svg";